export const loginedOptions = {
  dashboard: 'Dashboard',
  logout: 'Logout',
} as const;

export const loginedOptionsList = Object.values(loginedOptions);
